export default __webpack_public_path__ + "static/media/logo_lair.fd8f7223.png";